import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import BrandModel from "../../../models/BrandModel";
import BrandReferenceModel from "../../../models/BrandReferenceModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface BrandReferencesUpdateModel {
    brandId: number
    brandReferences: BrandReferenceModel[]
}

interface Props {
    show: boolean
    onHide: () => void
    brand: BrandModel
}

const EditBrandReferencesPopup: React.FC<Props> = ({ show, onHide, brand }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<BrandReferencesUpdateModel>();

    useEffect(() => {
        DataService.get<BrandReferenceModel[]>('api/v1/BrandReferences/ByBrand/' + brand.id)
            .then(response => {
                setFormData({
                    brandId: brand.id,
                    brandReferences: response
                })
            })
    }, [brand]);

    function submit() {
        if (formData) {
            DataService
                .update(`api/v1/BrandReferences`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData?.brandReferences) {
        formData.brandReferences.forEach((brandReference, index) => {
            formConfig.fields.push({ name: `brandReferences.${index}.referenceCode`, label: brandReference.externalSystemName, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] });
            formConfig.fields.push({ name: `brandReferences.${index}.readyForExportOn`, label: 'Ready for export on' });
            formConfig.fields.push({ name: `brandReferences.${index}.exportedOn`, label: 'Exported on' });
        })
    }

    const { getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Edit external references'} >
            <Popup.Body>
                {formData?.brandReferences && formData.brandReferences.length > 0 && (
                    <>
                        <table>
                            <tr>
                                <th className='col-md-2'></th>
                                <th className='col-md-6'><Translate>Reference code</Translate></th>
                                <th className='col-md-2'><Translate>Ready for export</Translate></th>
                                <th className='col-md-2'><Translate>Exported</Translate></th>
                            </tr>
                            {formData.brandReferences.map((brandReference, index) => {
                                return (
                                    <tr>
                                        <td><Form.Label>{brandReference.externalSystemName}</Form.Label></td>
                                        <td><TextboxControl {...getControlProps(`brandReferences.${index}.referenceCode`)} key={index} /></td>
                                        <td><DateControl {...getControlProps(`brandReferences.${index}.readyForExportOn`)} disabled key={index} /></td>
                                        <td><DateControl {...getControlProps(`brandReferences.${index}.exportedOn`)} disabled key={index} /></td>
                                    </tr>
                                )
                            })
                            }
                        </table>
                    </>
                )}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default EditBrandReferencesPopup;